import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { useIsStaffUser } from '@/hooks/useIsStaffUser';
import { SignedInPageLayout } from '@/layout/signed-in-page';

import { GlobalCopilotConversationsPage } from './GlobalCopilotConversations.page';

export const GlobalCopilotPage = () => {
  const { t } = useTranslation();
  const isStaff = useIsStaffUser();

  return (
    <SignedInPageLayout
      items={[]}
      navBarProps={{
        title: t('global.copilot.title'),
        showSearchBar: false,
      }}
    >
      <Stack spacing={10}>{isStaff && <GlobalCopilotConversationsPage />}</Stack>
    </SignedInPageLayout>
  );
};
